<template>
  <div class="base-selector" style="display: flex; align-items: center">
    <b-form-radio-group
      id="radio-group-base"
      class="m-1 baseGroup"
      button-variant="primary"
      buttons
      v-model="climateBase"
      size="lg"
      v-if="viewType == 'mapView' && modelType == 'climate'"
    >
      <b-form-radio
        value="HU"
        title="Rácsponti megjelenítés Magyarországra"
        v-b-tooltip.hover
        >Országos</b-form-radio
      >
      <b-form-radio
        value="ME"
        title="Megyékre átlagolt megjelenítés"
        v-b-tooltip.hover
        >Vármegyei</b-form-radio
      >
      <b-form-radio
        value="JA"
        title="Járásokra átlagolt megjelenítés"
        v-b-tooltip.hover
        >Járási</b-form-radio
      >
    </b-form-radio-group>

    <div
      v-if="viewType == 'mapView' && modelType == 'city'"
      style="display: flex"
    >
      <b-select v-model="citySelector" size="lg" class="city-select m-1">
        <option value="BP" selected>Budapest</option>
        <option value="SZ">Szeged</option>
      </b-select>
      <b-form-radio-group
        id="radio-group-base"
        class="m-1 baseGroup"
        buttons
        v-model="cityType"
        size="lg"
        style="flex-grow: 0"
        button-variant="primary"
        v-if="citySelector == 'BP'"
      >
        <b-form-radio
          value="BP"
          title="Rácsponti megjelenítés Budapestre"
          v-b-tooltip.hover
          >Városi</b-form-radio
        >
        <b-form-radio
          value="BK"
          title="Kerületekre átlagolt megjelenítés"
          v-b-tooltip.hover
          >Városrészi</b-form-radio
        >
      </b-form-radio-group>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  name: "BaseSelector",
  props: {
    value: {
      type: String,
      default: "",
    },
    viewType: {
      type: String,
      default: "mapView",
    },
    modelType: {
      type: String,
      default: "climate",
    },
    containerNumber: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      base: "HU",
      citySelector: "BP",
      climateBase: "HU",
      cityType: "BP",
      extentName: "Magyarország",
    };
  },
  computed: {
    computedBase() {
      let base = "";
      let extentName = "";
      let citySelector = this.citySelector;
      console.warn("base computed");
      if (this.modelType == "climate") {
        extentName = "Magyarország";
        base = this.climateBase;
      } else {
        if (citySelector == "BP") {
          base = this.cityType;
          extentName = "Budapest";
        } else {
          base = this.citySelector;
          extentName = "Szeged";
        }
      }
      //this.base = base;
      this.$emit("input", base);
      this.extentName = extentName;
      //this.$root.$refs.MapRef.setKozigLayerVisible(base, this.containerNumber);
      // TODO: Eztmegoldani szegedre is

      //this.$root.$refs.MapRef.changeExtent(extentName);
      return base;
    },
  },
  watch: {
    extentName(newVal) {
      if (this.$root.$refs.MapRef && this.$root.$refs.MapRef.changeExtent)
        this.$root.$refs.MapRef.changeExtent(newVal);
      console.log("change extent");
    },
    computedBase(newVal) {
      this.$root.$refs.MapRef.setKozigLayerVisible(
        newVal,
        this.containerNumber,
      );
    },
    modelType(newVal) {
      var extentName = "";
      if (this.modelType == "city") {
        //TODO: Itt kell figyelembe venni a cityselectet is
        if (this.citySelector == "BP") {
          extentName = "Budapest";
          this.base = "BP";
        } else {
          extentName = "Szeged";
          this.base = "SZ";
        }
        //extentName = "Budapest";
        //this.base = "BP";
      } else {
        extentName = "Magyarország";
        this.base = "HU";
      }
      //TODO: Ezt javítani, nagypn csúnya megoldás
      //this.$root.$refs.MapRef.changeExtent(extentName);

      //TODO: valami ilyent kellene csinálni:
      //this.$store.state.parameterStripe.felbontas = "HUM000";
    },
    base(newVal) {
      this.$emit("input", newVal);
      this.$root.$refs.MapRef.setKozigLayerVisible(
        newVal,
        this.containerNumber,
      );
    },
    citySelector(newVal) {
      console.warn("city selector changed:", newVal);
      this.$store.state.parameterStripe[
        "baseCitySelect" + this.containerNumber
      ] = newVal;
      //TODO: itt kijavítani, ha Szegedről Budapestre váltunk, akkor legyen a Budapest városi kiválasztva
      if (this.modelType == "city") {
        if (newVal == "BP") {
          this.cityType = "BP";
        } /*else {
          this.cityType = "SZ";
        }*/
      }
    },
    "$store.state.parameterStripe.baseCitySelect1"(newVal) {
      if (
        this.containerNumber == 2 &&
        this.modelType ==
          "city" /*&&
        this.$store.state.parameterStripe.compare*/
      ) {
        this.citySelector = newVal;
      }
    },
    "$store.state.parameterStripe.baseCitySelect2"(newVal) {
      if (this.containerNumber == 1 && this.modelType == "city") {
        this.citySelector = newVal;
      }
    },
    value(newVal) {
      console.warn("base selector value prop changed:", newVal);
      //this.base = newVal;
      if (this.modelType == "climate") {
        this.climateBase = newVal;
      } else {
        console.warn("setting city type to:", newVal);
        this.cityType = newVal;
        //TODO: itt kellene figyelembe venni a cityselectet is, illetve base-t kell-e állítani
      }
    },
  },
  methods: {
    // Component methods here
  },
};
</script>

<style scoped>
.city-select {
  width: 85px;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 1.25rem;
}
</style>
